<script lang="ts">
import { InternationalizedLabel } from '@/interfaces/InternationalizedLabel';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

/**
 * @deprecated When every component communicate using InternationalizedLabel as object, this Mixin won't be useful anymore as we will be able to direct call VueI18n functions
 */
@Component
export default class TranslateMixin extends Vue {
  public exists(label: InternationalizedLabel): boolean {
    if (typeof label === 'string') {
      return this.$te(label);
    }
    return this.$te(label.key);
  }

  public translate(label: InternationalizedLabel): string {
    if (typeof label === 'string') {
      return this.$t(label).toString();
    }
    return this.$t(label.key, label.params).toString();
  }
}
</script>
